// extracted by mini-css-extract-plugin
module.exports = {"root":"flammable-waste-disposal-page_root__xP0V_"};